import React, { createContext, useContext } from "react";

const WorkspaceContext = createContext(null);

export function WorkspaceProvider({ value, children }) {
  return <WorkspaceContext.Provider value={value}>{children}</WorkspaceContext.Provider>;
}

export const useWs = () => useContext(WorkspaceContext);
